import { Autocomplete } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDebounce } from '../../utils/hooks'
import AutocompleteInput from '../UI/AutocompleteInput'

type SearchInputProps = {
  onChange: (value: string) => void
  options: Array<string>
}

const SearchInput = ({ onChange, options }: SearchInputProps): JSX.Element => {
  const [selectedProvider, setSelectedProvider] = useState<string>()
  const [value, setValue] = useState<string>('')
  const debouncedValue = useDebounce(value || '')

  useEffect(() => {
    onChange(debouncedValue)
  }, [debouncedValue])

  return (
    <Autocomplete
      className="provider-name"
      onInputChange={(e, newValue) => {
        setSelectedProvider(
          options.find((opt) => opt === newValue) || undefined
        )
        setValue(newValue)
      }}
      options={options}
      value={selectedProvider || null}
      renderInput={(params) => (
        <AutocompleteInput {...params} placeholder="Provider name" />
      )}
    />
  )
}

export default SearchInput
